import { SVG } from '../svg';
import { IconProps } from '../types';

export function SearchIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.3-4.3" />
    </SVG>
  );
}
